import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout")({
    component: () => <PingtreeLayout />,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.report.pingtree.title"),
        asActive: true,
    }),
});

function PingtreeLayout() {
    return <Outlet />;
}
